import React, { useState } from 'react';
import { Search, Eye, Trash, X, Edit, Phone, MessageSquare, FileText, Download } from 'lucide-react';
// Sample patient data
const samplePatients = [{
  id: 1,
  firstName: 'Sarah',
  lastName: 'Johnson',
  email: 'sarah.johnson@example.com',
  phone: '(555) 123-4567',
  dateOfBirth: 'May 12, 1975',
  age: 48,
  gender: 'Female',
  address: '123 Main Street, Apt 4B, New York, NY 10001',
  nationality: 'American',
  profession: 'Marketing Manager',
  bloodGroup: 'O+',
  emergencyContact: 'Michael Johnson (Husband)',
  emergencyNumber: '(555) 123-4568',
  employerName: 'Digital Media Corp',
  documents: [{
    name: 'registration-form',
    date: '2026-01-14',
    type: 'registration'
  }],
  idDocument: {
    type: 'Driver License',
    number: 'DL-NY-4829374',
    issueDate: '15/05/2020',
    expiryDate: '15/05/2028',
    issuingAuthority: 'New York DMV',
    documentImage: 'drivers-license-sarah-johnson.pdf'
  },
  calls: [{
    type: 'AI Voice Agent Call',
    reason: 'Patient Registration - New Patient Intake',
    date: '14th January, 2026',
    time: '10:17am',
    duration: '03:23'
  }],
  messages: [{
    subject: 'Registration Confirmation',
    preview: 'Welcome to our practice! Your registration has been completed...',
    date: '14th January, 2026',
    channel: 'WhatsApp'
  }]
}, {
  id: 2,
  firstName: 'James',
  lastName: 'Cooper',
  email: 'james.cooper@example.com',
  phone: '(555) 234-5678',
  dateOfBirth: 'August 22, 1988',
  age: 38,
  gender: 'Male',
  address: '456 Oak Avenue, Boston, MA 02101',
  nationality: 'American',
  profession: 'Software Engineer',
  bloodGroup: 'A+',
  emergencyContact: 'Emily Cooper (Wife)',
  emergencyNumber: '(555) 234-5679',
  employerName: 'Tech Solutions Inc',
  documents: [{
    name: 'registration-form',
    date: '2026-01-13',
    type: 'registration'
  }],
  idDocument: {
    type: 'Driver License',
    number: 'DL-MA-8374920',
    issueDate: '22/08/2022',
    expiryDate: '22/08/2030',
    issuingAuthority: 'Massachusetts RMV',
    documentImage: 'drivers-license-james-cooper.pdf'
  },
  calls: [{
    type: 'AI Voice Agent Call',
    reason: 'Patient Registration - New Patient Intake',
    date: '13th January, 2026',
    time: '2:45pm',
    duration: '04:12'
  }],
  messages: [{
    subject: 'Registration Confirmation',
    preview: 'Welcome to our practice! Your registration has been completed...',
    date: '13th January, 2026',
    channel: 'WhatsApp'
  }]
}, {
  id: 3,
  firstName: 'Maria',
  lastName: 'Santos',
  email: 'maria.santos@example.com',
  phone: '(555) 345-6789',
  dateOfBirth: 'March 15, 1992',
  age: 34,
  gender: 'Female',
  address: '789 Pine Street, Miami, FL 33101',
  nationality: 'American',
  profession: 'Nurse',
  bloodGroup: 'B+',
  emergencyContact: 'Carlos Santos (Brother)',
  emergencyNumber: '(555) 345-6790',
  employerName: 'Miami General Hospital',
  documents: [{
    name: 'registration-form',
    date: '2026-01-12',
    type: 'registration'
  }],
  idDocument: {
    type: 'Driver License',
    number: 'DL-FL-2938475',
    issueDate: '15/03/2024',
    expiryDate: '15/03/2032',
    issuingAuthority: 'Florida DMV',
    documentImage: 'drivers-license-maria-santos.pdf'
  },
  calls: [{
    type: 'AI Voice Agent Call',
    reason: 'Patient Registration - New Patient Intake',
    date: '12th January, 2026',
    time: '9:30am',
    duration: '02:58'
  }],
  messages: [{
    subject: 'Registration Confirmation',
    preview: 'Welcome to our practice! Your registration has been completed...',
    date: '12th January, 2026',
    channel: 'WhatsApp'
  }]
}];
const Patients = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const filteredPatients = samplePatients.filter(patient => patient.firstName.toLowerCase().includes(searchQuery.toLowerCase()) || patient.lastName.toLowerCase().includes(searchQuery.toLowerCase()) || patient.email.toLowerCase().includes(searchQuery.toLowerCase()) || patient.phone.includes(searchQuery));
  const handleViewPatient = patient => {
    setSelectedPatient(patient);
  };
  const handleBackToList = () => {
    setSelectedPatient(null);
  };
  if (selectedPatient) {
    return <div className="flex flex-col h-full overflow-hidden" data-id="element-1450">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between mb-4 gap-3 flex-shrink-0" data-id="element-1451">
          <div data-id="element-1452">
            <button onClick={handleBackToList} className="text-black hover:underline text-sm mb-2" data-id="element-1453">
              ← Back to Patients
            </button>
            <div className="flex items-center gap-3" data-id="element-1454">
              <div className="h-12 w-12 rounded-full bg-gray-200 flex items-center justify-center text-lg font-medium" data-id="element-1455">
                {selectedPatient.firstName[0]}
                {selectedPatient.lastName[0]}
              </div>
              <div data-id="element-1456">
                <h1 className="text-xl sm:text-2xl font-bold tracking-tight" data-id="element-1457">
                  {selectedPatient.firstName} {selectedPatient.lastName}
                </h1>
                <p className="text-sm text-muted-foreground" data-id="element-1458">
                  {selectedPatient.age} years old ({selectedPatient.dateOfBirth}
                  )
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="flex-1 overflow-y-auto" data-id="element-1459">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-4" data-id="element-1460">
            {/* ID Document Section */}
            <div className="border rounded-md p-4" data-id="element-1461">
              <h3 className="font-medium mb-3 flex items-center gap-2" data-id="element-1462">
                <FileText size={18} className="text-black" data-id="element-1463" />
                ID Document
              </h3>
              <div className="bg-blue-50 border border-blue-200 rounded-md p-4 mb-3" data-id="element-1464">
                <div className="grid grid-cols-2 gap-3 text-sm" data-id="element-1465">
                  <div data-id="element-1466">
                    <div className="text-xs text-muted-foreground mb-1" data-id="element-1467">
                      Document Type
                    </div>
                    <div className="font-medium" data-id="element-1468">
                      {selectedPatient.idDocument.type}
                    </div>
                  </div>
                  <div data-id="element-1469">
                    <div className="text-xs text-muted-foreground mb-1" data-id="element-1470">
                      Document Number
                    </div>
                    <div className="font-medium" data-id="element-1471">
                      {selectedPatient.idDocument.number}
                    </div>
                  </div>
                  <div data-id="element-1472">
                    <div className="text-xs text-muted-foreground mb-1" data-id="element-1473">
                      Issue Date
                    </div>
                    <div className="font-medium" data-id="element-1474">
                      {selectedPatient.idDocument.issueDate}
                    </div>
                  </div>
                  <div data-id="element-1475">
                    <div className="text-xs text-muted-foreground mb-1" data-id="element-1476">
                      Expiry Date
                    </div>
                    <div className="font-medium" data-id="element-1477">
                      {selectedPatient.idDocument.expiryDate}
                    </div>
                  </div>
                  <div className="col-span-2" data-id="element-1478">
                    <div className="text-xs text-muted-foreground mb-1" data-id="element-1479">
                      Issuing Authority
                    </div>
                    <div className="font-medium" data-id="element-1480">
                      {selectedPatient.idDocument.issuingAuthority}
                    </div>
                  </div>
                </div>
              </div>
              <button className="w-full flex items-center justify-center gap-2 bg-black text-white py-2 rounded-md text-sm hover:bg-gray-800" data-id="element-1481">
                <Download size={16} data-id="element-1482" />
                Download ID Document
              </button>
            </div>

            {/* Registration Documents Section */}
            <div className="border rounded-md p-4" data-id="element-1483">
              <h3 className="font-medium mb-3" data-id="element-1484">Registration Documents</h3>
              <div className="space-y-2 mb-4" data-id="element-1485">
                {selectedPatient.documents.map((doc, index) => <div key={index} className="flex items-center justify-between p-2 hover:bg-gray-50 rounded" data-id="element-1486">
                    <div className="flex items-center gap-2" data-id="element-1487">
                      <FileText size={16} className="text-gray-400" data-id="element-1488" />
                      <div data-id="element-1489">
                        <div className="text-sm font-medium" data-id="element-1490">{doc.name}</div>
                        <div className="text-xs text-muted-foreground" data-id="element-1491">
                          {doc.date}
                        </div>
                      </div>
                    </div>
                    <div className="flex items-center gap-2" data-id="element-1492">
                      <button className="p-1 hover:bg-gray-100 rounded" data-id="element-1493">
                        <Eye size={16} data-id="element-1494" />
                      </button>
                      <button className="p-1 hover:bg-gray-100 rounded" data-id="element-1495">
                        <Trash size={16} className="text-red-500" data-id="element-1496" />
                      </button>
                    </div>
                  </div>)}
              </div>
              <button className="w-full bg-black text-white py-2 rounded-md text-sm hover:bg-gray-800" data-id="element-1497">
                Upload Documents
              </button>
            </div>
          </div>

          {/* Call History */}
          {selectedPatient.calls.length > 0 && <div className="border rounded-md p-4 mb-4" data-id="element-1498">
              <h3 className="font-medium mb-3 flex items-center gap-2" data-id="element-1499">
                <Phone size={18} className="text-black" data-id="element-1500" />
                Call History
              </h3>
              <div className="space-y-2" data-id="element-1501">
                {selectedPatient.calls.map((call, index) => <div key={index} className="flex items-center justify-between p-2 hover:bg-gray-50 rounded" data-id="element-1502">
                    <div data-id="element-1503">
                      <div className="text-sm font-medium" data-id="element-1504">{call.type}</div>
                      <div className="text-xs text-muted-foreground" data-id="element-1505">
                        {call.reason}
                      </div>
                    </div>
                    <div className="text-right" data-id="element-1506">
                      <div className="text-xs text-muted-foreground" data-id="element-1507">
                        {call.date}
                      </div>
                      <div className="text-xs text-muted-foreground" data-id="element-1508">
                        {call.time} • {call.duration}
                      </div>
                    </div>
                  </div>)}
              </div>
            </div>}

          {/* Message History */}
          {selectedPatient.messages.length > 0 && <div className="border rounded-md p-4 mb-4" data-id="element-1509">
              <h3 className="font-medium mb-3 flex items-center gap-2" data-id="element-1510">
                <MessageSquare size={18} className="text-black" data-id="element-1511" />
                Message History
              </h3>
              <div className="space-y-2" data-id="element-1512">
                {selectedPatient.messages.map((message, index) => <div key={index} className="flex items-start justify-between p-2 hover:bg-gray-50 rounded" data-id="element-1513">
                    <div className="flex-1" data-id="element-1514">
                      <div className="text-sm font-medium" data-id="element-1515">
                        {message.subject}
                      </div>
                      <div className="text-xs text-muted-foreground line-clamp-1" data-id="element-1516">
                        {message.preview}
                      </div>
                    </div>
                    <div className="text-right ml-2" data-id="element-1517">
                      <div className="text-xs text-muted-foreground" data-id="element-1518">
                        {message.date}
                      </div>
                      <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800 mt-1" data-id="element-1519">
                        {message.channel}
                      </span>
                    </div>
                  </div>)}
              </div>
            </div>}

          {/* Patient Information */}
          <div className="border rounded-md p-4" data-id="element-1520">
            <h3 className="font-medium mb-3" data-id="element-1521">Patient Information</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-4" data-id="element-1522">
              <div data-id="element-1523">
                <div className="text-xs text-muted-foreground mb-1" data-id="element-1524">Name</div>
                <div className="text-sm font-medium" data-id="element-1525">
                  {selectedPatient.firstName} {selectedPatient.lastName}
                </div>
              </div>
              <div data-id="element-1526">
                <div className="text-xs text-muted-foreground mb-1" data-id="element-1527">
                  Email Address
                </div>
                <div className="text-sm" data-id="element-1528">{selectedPatient.email}</div>
              </div>
              <div data-id="element-1529">
                <div className="text-xs text-muted-foreground mb-1" data-id="element-1530">
                  Contact
                </div>
                <div className="text-sm" data-id="element-1531">{selectedPatient.phone}</div>
              </div>
              <div data-id="element-1532">
                <div className="text-xs text-muted-foreground mb-1" data-id="element-1533">Gender</div>
                <div className="text-sm" data-id="element-1534">{selectedPatient.gender}</div>
              </div>
              <div data-id="element-1535">
                <div className="text-xs text-muted-foreground mb-1" data-id="element-1536">
                  Address
                </div>
                <div className="text-sm" data-id="element-1537">{selectedPatient.address}</div>
              </div>
              <div data-id="element-1538">
                <div className="text-xs text-muted-foreground mb-1" data-id="element-1539">
                  Nationality
                </div>
                <div className="text-sm" data-id="element-1540">{selectedPatient.nationality}</div>
              </div>
              <div data-id="element-1541">
                <div className="text-xs text-muted-foreground mb-1" data-id="element-1542">
                  Profession
                </div>
                <div className="text-sm" data-id="element-1543">{selectedPatient.profession}</div>
              </div>
              <div data-id="element-1544">
                <div className="text-xs text-muted-foreground mb-1" data-id="element-1545">
                  Blood Group
                </div>
                <div className="text-sm" data-id="element-1546">{selectedPatient.bloodGroup}</div>
              </div>
              <div data-id="element-1547">
                <div className="text-xs text-muted-foreground mb-1" data-id="element-1548">
                  Emergency Contact
                </div>
                <div className="text-sm" data-id="element-1549">
                  {selectedPatient.emergencyContact}
                </div>
              </div>
              <div data-id="element-1550">
                <div className="text-xs text-muted-foreground mb-1" data-id="element-1551">
                  Emergency Number
                </div>
                <div className="text-sm" data-id="element-1552">{selectedPatient.emergencyNumber}</div>
              </div>
              <div data-id="element-1553">
                <div className="text-xs text-muted-foreground mb-1" data-id="element-1554">
                  Employer's Name
                </div>
                <div className="text-sm" data-id="element-1555">{selectedPatient.employerName}</div>
              </div>
            </div>
            <div className="flex justify-end" data-id="element-1556">
              <button onClick={() => setShowUpdateModal(true)} className="bg-black text-white px-6 py-2 rounded-md text-sm hover:bg-gray-800" data-id="element-1557">
                Update Details
              </button>
            </div>
          </div>
        </div>
      </div>;
  }
  return <div className="flex flex-col h-full overflow-hidden" data-id="element-1558">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between mb-4 gap-3 flex-shrink-0" data-id="element-1559">
        <div data-id="element-1560">
          <h1 className="text-xl sm:text-2xl font-bold tracking-tight" data-id="element-1561">
            Patients
          </h1>
          <p className="text-muted-foreground text-sm" data-id="element-1562">
            Manage patient profiles and information
          </p>
        </div>
        <button className="inline-flex items-center justify-center rounded-md bg-black px-4 py-2 text-sm font-medium text-white hover:bg-gray-800" data-id="element-1563">
          Add New Patient
        </button>
      </div>

      <div className="mb-4 flex-shrink-0" data-id="element-1564">
        <div className="relative" data-id="element-1565">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" data-id="element-1566" />
          <input type="text" placeholder="Search patients by name, email, or phone..." className="h-10 w-full rounded-md border border-input bg-background pl-10 pr-4 text-sm focus:outline-none focus:ring-2 focus:ring-black" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-1567" />
        </div>
      </div>

      <div className="flex-1 overflow-hidden rounded-md border" data-id="element-1568">
        <div className="hidden md:grid md:grid-cols-12 gap-4 p-4 text-sm font-medium border-b bg-muted/30 flex-shrink-0" data-id="element-1569">
          <div className="col-span-3" data-id="element-1570">Name</div>
          <div className="col-span-3" data-id="element-1571">Email</div>
          <div className="col-span-2" data-id="element-1572">Phone</div>
          <div className="col-span-2" data-id="element-1573">Age</div>
          <div className="col-span-2" data-id="element-1574">Actions</div>
        </div>
        <div className="divide-y divide-border overflow-y-auto h-full" data-id="element-1575">
          {filteredPatients.length === 0 ? <div className="p-6 text-center text-muted-foreground" data-id="element-1576">
              No patients found.
            </div> : filteredPatients.map(patient => <div key={patient.id} className="grid grid-cols-1 md:grid-cols-12 gap-4 p-4 text-sm items-center hover:bg-muted/20" data-id="element-1577">
                <div className="md:col-span-3" data-id="element-1578">
                  <div className="flex items-center gap-3" data-id="element-1579">
                    <div className="h-10 w-10 rounded-full bg-gray-200 flex items-center justify-center text-sm font-medium flex-shrink-0" data-id="element-1580">
                      {patient.firstName[0]}
                      {patient.lastName[0]}
                    </div>
                    <div data-id="element-1581">
                      <button onClick={() => handleViewPatient(patient)} className="font-medium text-left hover:text-black hover:underline" data-id="element-1582">
                        {patient.firstName} {patient.lastName}
                      </button>
                      <div className="text-xs text-muted-foreground md:hidden" data-id="element-1583">
                        {patient.email}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="md:col-span-3 hidden md:block" data-id="element-1584">
                  {patient.email}
                </div>
                <div className="md:col-span-2" data-id="element-1585">
                  <span className="md:hidden text-muted-foreground text-xs" data-id="element-1586">
                    Phone:{' '}
                  </span>
                  {patient.phone}
                </div>
                <div className="md:col-span-2" data-id="element-1587">
                  <span className="md:hidden text-muted-foreground text-xs" data-id="element-1588">
                    Age:{' '}
                  </span>
                  {patient.age} years
                </div>
                <div className="md:col-span-2" data-id="element-1589">
                  <button onClick={() => handleViewPatient(patient)} className="inline-flex items-center gap-1 text-black hover:underline text-sm" data-id="element-1590">
                    <Eye size={16} data-id="element-1591" />
                    View Details
                  </button>
                </div>
              </div>)}
        </div>
      </div>
    </div>;
};
export default Patients;